import React from 'react';
import Modal from './Modal';
import Badge, { readinessVariant } from './Badge';

const OPTIONS = [
  { level: 'Normal', note: 'Routine operations, no elevated posture.' },
  { level: 'Alert', note: 'Watching a developing situation — no resources committed yet.' },
  { level: 'Standby', note: 'Staff recalled, prepped and ready to go on short notice.' },
];

// Shared "Manage Readiness" modal for both Team and Hospital rows. Active is never a
// selectable option here — it's forced automatically when engaged on a live incident
// (see server readinessService.js) and rejected server-side if attempted directly.
export default function ReadinessModal({ open, subjectLabel, currentLevel, onClose, onSelect, busy }) {
  const isActive = currentLevel === 'Active';

  return (
    <Modal open={open} onClose={onClose} title="Manage Readiness" subtitle={subjectLabel} footer={null}>
      <div className="space-y-4">
        <div className="flex items-center gap-2 text-sm text-neutral-600 dark:text-neutral-300">
          <span>Current:</span>
          <Badge variant={readinessVariant(currentLevel)}>{currentLevel || 'Normal'}</Badge>
        </div>

        {isActive && (
          <div className="bg-amber-50 border border-amber-200 text-amber-800 text-xs rounded-lg p-3 dark:bg-amber-500/10 dark:border-amber-500/20 dark:text-amber-400">
            Active — set automatically while engaged on a live incident. It reverts to Standby
            when the incident closes and can't be changed manually here.
          </div>
        )}

        <div className="space-y-2">
          {OPTIONS.map((option) => (
            <button
              key={option.level}
              type="button"
              disabled={busy || isActive || option.level === currentLevel}
              onClick={() => onSelect(option.level)}
              className="w-full text-left px-4 py-3 rounded-lg border border-neutral-200 hover:border-seha-300 hover:bg-seha-50 transition-colors disabled:opacity-40 disabled:hover:border-neutral-200 disabled:hover:bg-transparent disabled:cursor-not-allowed dark:border-neutral-700 dark:hover:bg-seha-500/10 dark:disabled:hover:border-neutral-700"
            >
              <p className="text-sm font-bold text-neutral-800 dark:text-neutral-100">{option.level}</p>
              <p className="text-xs text-neutral-500 mt-0.5 dark:text-neutral-400">{option.note}</p>
            </button>
          ))}
        </div>
      </div>
    </Modal>
  );
}
